import { render, staticRenderFns } from "./Flyer.vue?vue&type=template&id=4aaea38e&"
import script from "./Flyer.vue?vue&type=script&lang=js&"
export * from "./Flyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports